

import { boolean } from "mathjs"
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator"

@Component({
	components: {
	}
})
export default class DisplayMessage extends Vue {
	@Prop({ type: Boolean, default: false })
	show!: boolean

	@Prop({ type: String, default: "danger" })
	variant!: string

	@Prop({ type: String, default: "fas fa-exclamation-circle" })
	iconClass!: string | null

	get messageClass () {
		return `alert-${this.variant}`
	}
}
